

























import { Component, Prop, Vue } from 'vue-property-decorator';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import {ContactType} from '@/features/contacts/models/contactType';
@Component({
	components: {
		DropDownMenu
	}
})
export default class ContactTypePicker extends Vue {
	@Prop({default: ContactType.Lead}) public value: ContactType;
	@Prop({default: false}) public disabled: boolean;

	public selectedType: ContactType = ContactType.User;
	public active: boolean = false;

	public mounted() {
		this.selectedType = this.value;
	}

	public getContactTypes(): ContactType[] {
		return [ContactType.Lead, ContactType.User];
	}

	public selectType(type: ContactType) {
		if (this.disabled) {
			return;
		}

		if (this.selectedType !== type) {
			this.$emit('updated-type', type);
		}
		this.selectedType = type;
		this.active = false;
	}

	public getFormattedType(type: ContactType): string {
		return `${type.charAt(0).toUpperCase()}${type.slice(1)}s`;
	}

	public setActive(isOpen: boolean) {
		if (this.disabled) {
			return;
		}

		this.active = isOpen;
	}
}
